import { Paper, Typography, Box } from "@mui/material";

const Footer = () => {
  return (
    <Paper sx={{ bottom: 0 }} elevation={3}>
      <Box>
        <Typography
          variant="body1"
          sx={{ fontSize: "12px", padding: "16px", textAlign: "center" }}
        >
          Copyright @{new Date().getFullYear()} All Rights Reserved
        </Typography>
      </Box>
    </Paper>
  );
};

export default Footer;
